var version = {
    "name":      "dativery",
    "buildDateCode": "20260525-151857",
    "buildDate": "Mon May 25 2026 15:18:57 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260525-151857",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;